import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class VenueServiceeService {

  venueSetting: any;

  constructor(private _http: HttpClient) {

  }

  getVouchersOrgSetting(org_id: string): Observable<any> {
    let url = environment.api + 'widget/organization';
    let params = new HttpParams()
      .set('hash', org_id)

    return this._http.get(url, { params }).pipe(
      map((s) => {
        console.log(s);
        //s['data'].setting.value = JSON.parse(s['data'].setting.value);
        return s['data']
      }
      ));
  }

  getVenueSetting(v_id: string): Observable<any> {
    let url = environment.api + 'widget/venue';
    let params = new HttpParams()
      .set('hash', v_id)

    return this._http.get(url, { params }).pipe(
      map((s) => {
        // console.log(s);
        s['data'].setting.value = JSON.parse(s['data'].setting.value);
        return s['data']
      }
      ));
  }

  getVouchersVenueSetting(v_id: string): Observable<any> {
    let url = environment.api + 'voucher/venue';
    let params = new HttpParams()
      .set('hash', v_id)

    return this._http.get(url, { params }).pipe(
      map((s) => {
        // console.log(s);
        s['data'].setting.value = JSON.parse(s['data'].setting.value);
        return s['data']
      }
      ));
  }

  getFieldSetting(v_id: string): Observable<any> {
    let url = environment.api + 'widget/setting';
    let params = new HttpParams()
      .set('hash', v_id);

    return this._http.get(url, { params });
  }

}
